<template>
    <div>
        <Teleport to="body">
            <transition name="fade-modal">
                <div class="modal d-block mm-modal" v-if="showModal" ref="modalsRef">
                    <div class="modal-dialog modal-dialog-scrollable" :class="[sizeClass]">
                        <div class="modal-content border-0" v-click-outside="hide">
                            <div v-if="!hideHeader" class="modal-header border-0 modal-header-color">
                                <h5 class="modal-title">{{title}}</h5><button type="button" aria-label="Close" class="close p-0 m-0" @click="hide"><svg width="16" height="16" viewBox="0 0 28 28">
                                    <line x1="0" y1="28" x2="28" y2="0" stroke="#f5f5f5" stroke-width="5" />
                                    <line x1="0" y1="0" x2="28" y2="28" stroke="#f5f5f5" stroke-width="5" />
                                </svg></button>
                            </div>
                            <div class="modal-body">
                                <slot name="default"></slot>
                            </div>
                            <div class="modal-footer justify-content-between">
                                <div>
                                    <slot name="buttons"></slot>
                                </div>
                                <button type="button" class="btn btn-secondary btn-neutral" @click="hide">{{txtClose}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <transition name="modal-backdrop">
                <div class="modal-backdrop" v-if="showModal"></div>
            </transition>
        </Teleport>
    </div>
</template>

<script>
import Teleport from 'vue2-teleport';

export default {
    name: 'mmModal',
    props: {
        title: String,
        size: String,
        textClose: String,
        hideHeader: Boolean
    },
    components: {
        Teleport,
    },
    data() {
            return {
                showModal: false,
                sizeClass: ''  
            }
    },
    created() {
        if(this.size)
            switch(this.size) {
                case 'lg': this.sizeClass = 'modal-lg'; break;
                case 'sm': this.sizeClass = 'modal-sm'; break;
            }
    },
    methods: {
        show() {
            if(this.hasScroll()) {
                
                document.body.classList.add('modal-open');
                document.body.style.paddingRight = '17px';
            }
            this.showModal = true;
            
            return new Promise((resolve) => {
                //cada vez que el DOM del modal es modificado se ejecuta esta funcion
                this.$nextTick(() => {
                    //aqui miramos que el ref no sea undefined
                    if (this.$refs.modalsRef) {
                        //esperamos un tiempo para asegurarnos que se renderizo completamente el elemento
                        setTimeout(()=>{resolve(true)}, 100)
                    }
                });
            });
        },
        hide() {
            if(this.showModal) {
                this.showModal = false;
                //se pone un poco de retardo para evitar el efecto no deseado de desplazamiento lateral de la modal
                setTimeout(()=> {
                    document.body.classList.remove('modal-open');
                    document.body.style.paddingRight = '0';
                }, 200);
            }  
        },
        hasScroll() {
            let docWidth = document.documentElement.clientWidth || document.body.clientWidth;

            return window.innerWidth > docWidth;
        }
     },
     computed: {
        txtClose() {
            return this.textClose ? this.textClose : 'Cerrar'
        }
  }
}
</script>

<style>
.fade-modal-enter-active,
.fade-modal-leave-active,
.modal-backdrop-enter-active,
.modal-backdrop-leave-active {
  transition: all .15s ease-out;
}

.fade-modal-enter,
.fade-modal-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

.modal-backdrop-enter,
.modal-backdrop-leave-to {
    opacity: 0;
}
</style>